export const environment = {
  production: true,
  urls: {
    getArticles: "http://bookshelf.schmidt-buch-verlag.de/articles",
    createArticle: "http://bookshelf.schmidt-buch-verlag.de/article",
    updateArticle: "http://bookshelf.schmidt-buch-verlag.de/article",
    updateArticleImage: "http://bookshelf.schmidt-buch-verlag.de/article/image",
    deleteArticle: "http://bookshelf.schmidt-buch-verlag.de/article",
    loginUser: "http://bookshelf.schmidt-buch-verlag.de/login",
    getAllUser: "http://bookshelf.schmidt-buch-verlag.de/users",
    deleteUser: "http://bookshelf.schmidt-buch-verlag.de/user",
    createUser: "http://bookshelf.schmidt-buch-verlag.de/user",
    img: "http://bookshelf.schmidt-buch-verlag.de/img"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts